export default {
  onboarding: {
    title: '¡Este es un SAFE Tag!',
    description: 'Puedes enlazar tu SAFE Tag y empezar a estar protegido por SOSAFE',
  },
  linkSafetag: 'Enlazar SAFE Tag',
  disclaimerSosafe: 'Descarga la última versión de SOSAFE para enlazar tu SAFE Tag',
};
